import React, { useState, useEffect, useCallback } from 'react';
import { Button, Space, Breadcrumb, Row, Col, Table} from 'antd';
import { CardLayout, RefCodeEditModal, LectureGroupEditModal } from 'components/molecules';
import { useLectureCategory, useLectureGroup } from 'hooks';
import { ColumnsType } from 'antd/lib/table/interface';
import { TotalNumMenu } from 'components/atoms';
import { usePopupManager } from 'react-popup-manager';
import { TableWrapper } from 'components/molecules';

export interface  LectureCommonProps {}

const  LectureCommon = ({}:  LectureCommonProps): React.ReactElement => {
 /* ======================================================
   * variables
   * ====================================================== */
 const [tableDatas, setTableDatas] = useState<any[]>();
 const [subTableDatas, setSubTableDatas] = useState<any[]>();
 const [cate, setCate] = useState<number>(99);
 const [cateName, setCateName] = useState<string>('과정');

 const { open } = usePopupManager();

 const columnsC: ColumnsType<LectureCategoryListDto> = [
   {
    title: '번호',
    dataIndex: 'cid',
    key: 'cid',
    width: '50px',
    align: 'center',
    render: (cid, record) => {
      return (
        <>{cid===99?'':cid}</>
      )
    }       
   },  
   {
     title: '분류명',
     dataIndex: 'cname',
     key: 'cname',
     width: 'auto',
     align: 'left',
     render: (cname, record) => {
      return (
        <>{cname}&nbsp;({record.cnt})</>
      )
    }     
   },
   {
    title: '수정',
    key: 'cate_edit',
    width: '80px',
    align: 'center',
    render: (record) => {
      return (
        <Button
          type='default'
          onClick={(e) => {
            e.stopPropagation();

            open(RefCodeEditModal, {
              title: '분류',      
              ref_code_srl: record.cid,
              value: record.cname,
              onClose: (isOk, value) => {
                if (isOk) {
                  categoryUpdate({cid: record.cid, cname: value})     
                }
              },
            }); 
            
          }}
        >수정</Button>
      )
    }
  }, 
 ];

 const columnsG: ColumnsType<LectureGroupListDto> = [
  {
    title: '번호',
    dataIndex: 'gid',
    key: 'gid',
    width: '50px',
    align: 'center',
   },  
   {
    title: '과정명',
    dataIndex: 'gname',
    key: 'gname',
    width: 'auto',
    align: 'left',
  },   
   {
    title: '장소',
    dataIndex: 'online_yn',
    key: 'online_yn',
    width: '100px',
    align: 'center',
    render: (online_yn, record) => {
      return (
        online_yn==='Y'?'온라인':'오프라인'
      )
    } 
  },
  {
    title: '교육비',
    dataIndex: 'price',
    key: 'price',
    width: '120px',
    align: 'right',
    render: (price, record) => {
      return (
        price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      )
    } 
  },  
  {
    title: '분류명',
    dataIndex: 'cname',
    key: 'cname',
    width: 'auto',
    align: 'left',
  },
  /*
   {
    title: '영문 과정명',
    dataIndex: 'gname_eng',
    key: 'gname_eng',
    width: '300px',
    align: 'left',
  },
  */
   {
     title: '사용여부',
     dataIndex: 'use_yn',
     key: 'use_yn',
     width: '80px',
     align: 'center',
     render: (use_yn, record) => {
       return (
         <Button
           type='default'
           onClick={(e) => {
             e.stopPropagation();
             groupUpdate({...record, use_yn:use_yn==='Y'?'N':'Y'});
           }}
         >{use_yn === 'Y' ? 'YES' : 'NO'}</Button>
       )
     }
   }, 
 ];

 /* ======================================================
  * hooks
  * ====================================================== */
 const { cateList, categoryInsert, categoryUpdate } = useLectureCategory();    
 const { groupList, groupInsert, groupUpdate, groupDelete } = useLectureGroup(cate);    

  /* ======================================================
   * events
   * ====================================================== */    

 const onClickRegister = () => {
   open(RefCodeEditModal, {
     title: '분류',
     ref_code_srl: 0,
     onClose: (isOk, value) => {
       if (isOk) {
         categoryInsert({
           cid: 0,
           cname: value,
         })    
       }
     },
   }); 
 }

 const onClickRegisterSub = () => {
  open(LectureGroupEditModal, {
    ginfo:{
      gid:0,
      cid:cate,
      cname:'',
      gname:'',
      gname_eng:'',
      price:0,
      online_yn:'N',
      use_yn:'Y',
      sale_yn:'N',
      point_yn: 'N',
    },
    clist: cateList,
    onDelete: onDeleteClick,
    onClose: (isOk, cid, gname, gname_eng, price, online_yn, use_yn, sale_yn, point_yn) => {
      if (isOk) {
        groupInsert({
          gid:0,
          cid:cid,
          gname:gname,
          gname_eng:gname_eng,
          price:price,
          online_yn:online_yn,
          use_yn:use_yn,
          sale_yn:sale_yn,
          point_yn: point_yn,
        }) 
      }
    },
  });  
 }  

 const onRowCateClick = useCallback((record, index) => {
  return {
    onClick: () => {
      setCate(record.cid);
      setCateName('과정 - ' + record.cname);
    },
  };
 }, []);

 const onDeleteClick = (gid:number) => {
  groupDelete({gid:gid})
 }
 const onRowGroupClick = (record, index) => {
  return {
    onClick: () => {
      open(LectureGroupEditModal, {
        ginfo: record,
        clist: cateList,
        onDelete: onDeleteClick,
        onClose: (isOk, cid, gname, gname_eng, price, online_yn, use_yn, sale_yn, point_yn) => {
          if (isOk) {
            groupUpdate({
              gid:record.gid,
              cid:cid,
              gname:gname,
              gname_eng:gname_eng,
              price:price,
              online_yn:online_yn,
              use_yn:use_yn,
              sale_yn:sale_yn,
              point_yn:point_yn,
            })   
          }
        },
      });    
    },
  };
 };

  /* ======================================================
   * effects
   * ====================================================== */
  useEffect(() => {
   setTableDatas(cateList?.map((item) => ({
     ...item,
     key: item.cid,
   })));
 }, [cateList]);

 useEffect(() => {
   setSubTableDatas(groupList?.map((item) => ({
     ...item,
     key: item.gid,
   })));
 }, [groupList]);  
  /* ======================================================
   * render items
   * ====================================================== */
  return (
    <CardLayout title={(
      <Breadcrumb>
        <Breadcrumb.Item>Home</Breadcrumb.Item>
        <Breadcrumb.Item>B2C</Breadcrumb.Item>
        <Breadcrumb.Item>공개교육과정관리</Breadcrumb.Item>
    </Breadcrumb>      
    )}>
      <Row gutter={[18, 24]} align="top">          
        <Col span={6}>
          <Space direction="vertical" style={{ width: '100%' }} >
            <TotalNumMenu text={'분류'} useRegister onUseRegister={onClickRegister}/>
            <TableWrapper isSearch={false}>
              <Table
                dataSource={tableDatas}
                columns={columnsC}
                pagination={false}
                style={{ width: '100%', overflowX: 'auto' }}
                className="columnCenterFixTable"
                onRow={onRowCateClick}
              />          
            </TableWrapper>              
          </Space>                
        </Col>
        <Col span={18}>
          <Space direction="vertical" style={{ width: '100%' }} >
            <TotalNumMenu text={cateName} useRegister onUseRegister={onClickRegisterSub}/>
            <TableWrapper isSearch={false}>
              <Table
                dataSource={subTableDatas}
                columns={columnsG}
                pagination={false}
                style={{ width: '100%', overflowX: 'auto' }}
                className="columnCenterFixTable"
                onRow={onRowGroupClick}
              />          
            </TableWrapper>            
          </Space>                
        </Col>        
      </Row>               
    </CardLayout>
  )
};

export default  LectureCommon;    